import XSwitch from './XSwitch'

export default XSwitch
export { XSwitch }
